/** 全局主题色（与 src/index.css 中的 --themeColor 保持一致） */
export const THEME_COLOR = '#cced46';
